const API_BASE_URL = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

const buildMediaViewUrl = (filename) => {
  if (!filename) return '/placeholder-image.jpg';
  const cleanFilename = String(filename).replace(/^\/+/, '');
  return `${API_BASE_URL}/media/view/${cleanFilename}`;
};

/**
 * Convierte una URL de Wasabi a una URL del proxy local
 * @param {string} wasabiUrl - URL completa de Wasabi
 * @returns {string} - URL del proxy local
 */
export const getProxyImageUrl = (wasabiUrl) => {
  if (!wasabiUrl) return '/placeholder-image.jpg';
  
  try {
    // Extraer el filename de la URL de Wasabi
    // Ejemplo: https://s3.us-west-1.wasabisys.com/bucket/path/file.jpg -> path/file.jpg
    const url = new URL(wasabiUrl);
    const pathParts = url.pathname.split('/').filter(part => part !== '');
    
    // Remover el bucket name (primer elemento después de filtrar vacíos)
    const filename = pathParts.slice(1).join('/');
    
    return buildMediaViewUrl(filename);
  } catch (error) {
    return '/placeholder-image.jpg';
  }
};

/**
 * Verifica si una URL es de Wasabi
 * @param {string} url - URL a verificar
 * @returns {boolean}
 */
export const isWasabiUrl = (url) => {
  return url && url.includes('wasabisys.com');
};

/**
 * Obtiene la URL correcta para mostrar una imagen
 * @param {string} imageUrl - URL original de la imagen
 * @returns {string} - URL procesada para mostrar
 */
export const getDisplayImageUrl = (imageUrl) => {
  if (!imageUrl) return '/placeholder-image.jpg';

  const imageValue = typeof imageUrl === 'string'
    ? imageUrl
    : String(imageUrl.filename || imageUrl.url || imageUrl.path || '');

  if (!imageValue) return '/placeholder-image.jpg';

  if (imageValue.startsWith('data:') || imageValue.startsWith('blob:')) {
    return imageValue;
  }
  
  // Si es una URL de Wasabi, usar el proxy
  if (isWasabiUrl(imageValue)) {
    return getProxyImageUrl(imageValue);
  }

  if (API_BASE_URL && imageValue.startsWith(`${API_BASE_URL}/media/view/`)) {
    return imageValue;
  }

  if (imageValue.startsWith('/api/media/view/')) {
    return `${API_BASE_URL}${imageValue.replace('/api', '')}`;
  }

  if (imageValue.startsWith('/media/view/')) {
    return `${API_BASE_URL}${imageValue}`;
  }
  
  // Si es una URL externa válida, usarla directamente
  if (imageValue.startsWith('http')) {
    return imageValue;
  }

  if (imageValue.startsWith('/images/') || imageValue.startsWith('/placeholder')) {
    return imageValue;
  }
  
  return buildMediaViewUrl(imageValue);
};
